import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router";
import { addData } from "../store/userSlice";
import { useDispatch } from "react-redux";
import { useLocalStorage } from "../hooks";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useLocalStorage("accessToken", null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // call this function when you want to authenticate the user
  const login = async (data) => {
    setAccessToken({
      token: data.access_token,
      refresh: data.refresh_token,
    });
    dispatch(addData(data.user_detail));

    navigate("/");
  };

  const clearToken = () => {
    setAccessToken(null);
  };

  const logout = () => {
    setAccessToken(null);
  };

  const value = useMemo(
    () => ({
      accessToken,
      login,
      logout,
      clearToken,
    }),
    [accessToken]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
